import React from "react";
import SeoHead from "../components/SeoHead";

export default function PrivacyPolicy() {
  return (
    <div>
      <SeoHead
        title="Privacy Policy — Hand & Wrist Clinics"
        description="Privacy Policy for Hand & Wrist Clinics. Learn how we collect, use, and protect your personal information."
        url="https://www.handandwristclinics.com/privacy-policy"
      />

      <header className="ab-hero" style={{ minHeight: "260px" }}>
        <div className="ab-hero-inner">
          <nav className="ab-breadcrumb" aria-label="Breadcrumb">
            <a href="/">Home</a>
            <span className="ab-bc-sep">/</span>
            <span className="ab-bc-current">Privacy Policy</span>
          </nav>
          <div className="ab-eyebrow"><span></span> Legal</div>
          <h1 className="ab-title">Privacy <em>Policy</em></h1>
          <div className="ab-divider" />
          <p className="ab-hero-sub">How we collect, use, and protect your information.</p>
        </div>
      </header>

      <section className="section section-cream">
        <div className="container" style={{ maxWidth: "820px" }}>

          <div className="pp-meta">
            <span><strong>Effective Date:</strong> </span>
          </div>

          <p className="pp-intro">
            Hand &amp; Wrist Clinics ("we", "us", "our", or the "Clinic") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how information may be collected, used, and protected when you visit and use our website,{" "}
            <a href="https://www.handandwristclinics.com" className="pp-link">www.handandwristclinics.com</a> ("Website").
          </p>
          <p className="pp-intro">
            By using our Website, you acknowledge that you have read and understood this Privacy Policy.
          </p>

          <div className="pp-section">
            <h2 className="pp-heading">Information We Collect</h2>
            <p className="pp-text">We may collect information that you voluntarily provide when you contact us through the communication options available on our Website, including WhatsApp. This information may include:</p>
            <ul className="pp-list">
              <li>Name</li>
              <li>Phone number</li>
              <li>Email address, where provided</li>
              <li>Information you choose to share regarding your enquiry or appointment</li>
            </ul>

            <h3 className="pp-subheading">Health Information</h3>
            <p className="pp-text">
              If you voluntarily provide information relating to your health, symptoms, medical history, treatment, or other healthcare-related matters when contacting the Clinic, we may use that information to respond to your enquiry, arrange an appointment, or provide the requested healthcare-related assistance.
            </p>
            <p className="pp-text">We recommend that you share only information that is necessary for your enquiry or appointment.</p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">Information Collected Automatically</h2>
            <p className="pp-text">When you visit our Website, certain technical information may be collected automatically, such as:</p>
            <ul className="pp-list">
              <li>Browser type and version</li>
              <li>Operating system</li>
              <li>Device type</li>
              <li>IP address</li>
              <li>Pages visited</li>
              <li>Date and time of your visit</li>
              <li>General Website usage information</li>
            </ul>
            <p className="pp-text">This information may be used to maintain, secure, and improve the Website and understand how visitors use it.</p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">How We Collect Information</h2>
            <p className="pp-text">We collect information primarily when you voluntarily contact the Clinic through the communication options provided on the Website, including WhatsApp.</p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">How We Use Your Information</h2>
            <p className="pp-text">We may use the information you provide to:</p>
            <ul className="pp-list">
              <li>Respond to your enquiries</li>
              <li>Communicate with you regarding our healthcare services</li>
              <li>Schedule and manage appointments</li>
              <li>Respond to appointment requests received through WhatsApp</li>
              <li>Provide information about our services</li>
            </ul>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">Cookies and Similar Technologies</h2>
            <p className="pp-text">
              Our Website may use cookies or similar technologies to support Website functionality, security, analytics, and performance. You may control or disable cookies through your browser settings. Disabling certain cookies may affect some Website functionality.
            </p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">Security</h2>
            <p className="pp-text">
              We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no method of transmission over the Internet or electronic storage is 100% secure.
            </p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">Children's Privacy</h2>
            <p className="pp-text">Our Website is not specifically directed at children. We do not knowingly collect personal information from children.</p>
          </div>

          <div className="pp-section">
            <h2 className="pp-heading">Changes to This Privacy Policy</h2>
            <p className="pp-text">
              We may update this Privacy Policy from time to time to reflect changes in our services. We encourage you to review this Privacy Policy periodically.
            </p>
          </div>

          <div className="pp-section pp-contact-box">
            <h2 className="pp-heading">Contact Us</h2>
            <p className="pp-text">If you have any questions, concerns, or requests regarding this Privacy Policy or the handling of your personal information, please contact us:</p>
            <div className="pp-contact-details">
              <p><strong>Hand &amp; Wrist Clinics</strong></p>
              <p>Room No.2, Dept. of Orthopaedics, OPD Block, Opp. Cyber Gateway, Hitec City, Hyderabad</p>
              <p>Email: <a href="mailto:handandwristclinics@gmail.com" className="pp-link">handandwristclinics@gmail.com</a></p>
              <p>Phone: <a href="tel:+919573152875" className="pp-link">+91 9573152875</a></p>
            </div>
          </div>

        </div>
      </section>

      <style>{`
        .pp-meta {
          display: flex; gap: 24px; flex-wrap: wrap;
          font-size: 0.82rem; color: var(--muted);
          margin-bottom: 28px; padding-bottom: 20px;
          border-bottom: 1px solid var(--border);
        }
        .pp-intro {
          font-size: 0.97rem; color: var(--text); line-height: 1.8;
          margin-bottom: 16px;
        }
        .pp-section {
          margin-top: 40px; padding-top: 32px;
          border-top: 1px solid var(--border);
        }
        .pp-heading {
          font-family: 'Cormorant Garamond', serif;
          font-size: 1.45rem; font-weight: 700;
          color: var(--navy); margin-bottom: 14px;
        }
        .pp-subheading {
          font-size: 1rem; font-weight: 700;
          color: var(--indigo); margin: 20px 0 10px;
        }
        .pp-text {
          font-size: 0.92rem; color: var(--text);
          line-height: 1.8; margin-bottom: 12px;
        }
        .pp-list {
          padding-left: 20px; margin: 12px 0;
          display: grid; gap: 8px;
        }
        .pp-list li {
          font-size: 0.92rem; color: var(--text);
          line-height: 1.6; padding-left: 4px;
        }
        .pp-link {
          color: var(--indigo); text-decoration: none; font-weight: 500;
        }
        .pp-link:hover { text-decoration: underline; }
        .pp-contact-box {
          background: white; border-radius: 16px;
          padding: 32px; border: 1.5px solid var(--border);
          box-shadow: var(--shadow-sm);
        }
        .pp-contact-details {
          display: grid; gap: 8px; margin-top: 16px;
        }
        .pp-contact-details p {
          font-size: 0.92rem; color: var(--text); line-height: 1.7;
        }
      `}</style>
    </div>
  );
}
